var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75348 18.1952C7.72056 14.5706 3.94416 10.8084 0.305928 9.77938C-0.101976 9.64829 -0.101976 9.3599 0.305928 9.22226C3.95074 8.18666 7.72056 4.431 8.76005 0.799863C8.8719 0.400046 9.14164 0.400046 9.25349 0.799863C10.2864 4.431 14.0628 8.18666 17.6945 9.22226C18.1024 9.35335 18.1024 9.64829 17.6945 9.77938C14.0562 10.8084 10.2798 14.5706 9.24691 18.1952C9.13506 18.6016 8.86532 18.6016 8.75348 18.1952Z",
    fill: "#A594FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e002fefba6f46a7b1e9da49ee0dd536e.svg";
export { ForwardRef as ReactComponent };